export function normalizeCompressorType(value) {
  switch (value) {
    case 'Schraubenkompressor(drehzahlgeregelt)':
      return 'Schraubenkompressor (drehzahlgeregelt)';
    case 'Schraubenkompressor(ohne Drehzahlregelung)':
      return 'Schraubenkompressor (ohne Drehzahlregelung)';
    default:
      return value;
  }
}
